var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section is-main-section"},[_c('profile-update-form',{staticClass:"tile is-child"}),_c('password-update-form',{staticClass:"tile is-child"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }